// extracted by mini-css-extract-plugin
module.exports = {"date":"InputTime_date_1RR-A","InputText_calendar":"InputTime_InputText_calendar_2Hxlh","InputBox":"InputTime_InputBox_ei7n9"};